export const CatchForm = ({ onSubmit }) => <form className="data-form" onSubmit={onSubmit}>
  <label>Jenis ikan<input name="species" required placeholder="Contoh: Tongkol" data-testid="catch-species-input" /></label>
  <label>Kapal<input name="vessel" required placeholder="Contoh: KM Sinar Laut" data-testid="catch-vessel-input" /></label>
  <div className="form-row">
    <label>Berat (kg)<input name="weight" type="number" required data-testid="catch-weight-input" /></label>
    <label>Nilai transaksi<input name="value" type="number" required data-testid="catch-value-input" /></label>
  </div>
  <button className="primary wide" type="submit" data-testid="catch-save-button">Simpan catatan</button>
</form>;
